<div class="card">
  <div *ngIf="!loading && !error" class="card-header bg-light">
      <div class="row align-items-center">
        <div class="col-md-6">
          <h5 class="mb-0">Plots for Location {{ selectedLocation!.label }}</h5>
          <p *ngIf="hasGapsStart" class="mb-0">{{ hasGapsStart }}</p>
          <p *ngIf="hasGapsEnd" class="mb-0">{{ hasGapsEnd }}</p>
          <p *ngIf="hasGapsWithinData" class="mb-0">{{ hasGapsWithinData }}</p>
        </div>
        <div class="col-md-6">
          <div class="d-flex align-items-center justify-content-end gap-3">
            <!-- Calendar day selector (defaults to today) -->
            <div class="d-flex align-items-center">
              <label for="plotDaySelector" class="me-2 mb-0">Ending date</label>
              <input
                id="plotDaySelector"
                type="date"
                class="form-control form-control-sm"
                style="width: 180px;"
                [(ngModel)]="selectedDate"
                (change)="onSelectedDateChange()"
                [ngModelOptions]="{standalone: true}"
              />
            </div>

            <!-- Interval selector -->
            <div class="d-flex align-items-center">
              <label for="intervalSelector" class="ms-3 me-2 mb-0">Interval</label>
              <select
                id="intervalSelector"
                class="form-select form-select-sm"
                style="width: 150px;"
                [(ngModel)]="intervalDurationSelected"
                (change)="onIntervalChange()"
                [ngModelOptions]="{standalone: true}"
              >
                <option value="1h">Hourly</option>
                <option value="15m">15 minute</option>
              </select>
            </div>
            <!-- Global toggles -->
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="checkbox"
                id="includeRegistersChk"
                [(ngModel)]="includeRegisters"
                [ngModelOptions]="{standalone: true}"
              />
              <label class="form-check-label" for="includeRegistersChk">Include registers</label>
            </div>

            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="checkbox"
                id="displayRegistersChk"
                [(ngModel)]="displayRegisters"
                (change)="onDisplayRegistersChange()"
                [ngModelOptions]="{standalone: true}"
              />
              <label class="form-check-label" for="displayRegistersChk">Display registers</label>
            </div>

            <button (click)="onShowPlotsButtonClick(locationId)" class="btn btn-outline-primary">Show Plot</button>
          </div>
        </div>
      </div>
  </div>
  <div class="card-body" *ngIf="showPlotBody">

    <!-- Loading indicator -->
    <div *ngIf="loading" class="text-center p-3">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">Fetching plot data ...</p>
    </div>

    <!-- Error message -->
    <div *ngIf="error" class="alert alert-danger">
      {{ error }}
    </div>

    <!-- Highcharts time series plot container -->
    <div class="mt-3">
      <div class="chart-wrapper" style="width: 100%; height: 600px;">
        <highcharts-chart
          [Highcharts]="Highcharts"
          [options]="chartOptions"
          [(update)]="updateFlag"
          [oneToOne]="true"
          style="width: 100%; height: 100%; display: block;"
        ></highcharts-chart>
      </div>
    </div>

  </div>

</div>
